import { render, staticRenderFns } from "./ItemFormManagement.vue?vue&type=template&id=036f49ba&scoped=true&"
import script from "./ItemFormManagement.vue?vue&type=script&lang=js&"
export * from "./ItemFormManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f49ba",
  null
  
)

export default component.exports